module.exports = __webpack_public_path__ + "static/media/siddharth-big-banyan-tree-trip-07.1aecb49a.png";